import React, {Component, useState} from "react";
import COLORS from "../../theme/colors";
import {
  List,
  Datagrid,
  Edit,
  Create,
  SimpleForm,
  TextField,
  DateField,
  EditButton,
  TextInput,
  
  ReferenceInput,
  ReferenceArrayInput,
  SelectInput,
  SelectArrayInput,
  DateTimeInput,
  translate,
  FunctionField,
  Show,
  SimpleShowLayout,

  ListButton,
  Filter,
  ShowButton,
  WithPermissions,
  TabbedShowLayout, 
  TabbedForm, 
  FormTab,
  NumberInput,
  DateInput,
  FormDataConsumer
} from "react-admin";
import CheckboxInput from "../../inputs/CheckboxInput";
import { CardActions } from "@material-ui/core";
import {
    required,
    password,
    passwordEdit,
    passwordEquals
} from "../../validators/validators";
import RoleSelectAppUser from '../../inputs/RoleSelectAppUser';
import RoleSelectGroupInput from '../../inputs/RoleSelectGroupInput';
import PdfDownloadButton from '../../button/PdfDownloadButton';
import { Grid } from "@material-ui/core";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faTrash, faPlus} from '@fortawesome/free-solid-svg-icons';
import { EmbeddedArrayInput } from '../../embedded-array/src';
import Card from '@material-ui/core/Card';
import MuiButton from '@material-ui/core/Button';
import ViewListIcon from '@material-ui/icons/ViewList';
import DateRangeIcon from '@material-ui/icons/DateRange';
import OrderCalendar from './OrderCalendar';
import Base64Image  from '../../inputs/Base64Image';
import Base64ImageInstallation  from '../../inputs/Base64ImageInstallation';
import ClientAdd  from '../../inputs/ClientAdd';
import SubscriberAdd  from '../../inputs/SubscriberAdd';


const BooleanTextField = ({ record = {}, source, style }) => (
  <span style={style}>{record[source] ? 'Da' : 'Ne'}</span>
);

const OrderFilter = props => (
  <Filter {...props}>
    <TextInput
      elStyle={{ width: 380 }}
      label="resources.misc.fields.id"
      source="id"
    />
    <TextInput
      elStyle={{ width: 380 }}
      label="resources.misc.fields.type"
      source="type"
    />
    <TextInput
      elStyle={{ width: 380 }}
      label="resources.misc.fields.clientCustomer"
      source="clientCustomer"
    />
    <TextInput
      elStyle={{ width: 380 }}
      label="resources.misc.fields.status"
      source="status"
    />
  </Filter>
);

const ShowDownloadButton = (props) => {
  const record = props.record;
  const isDone = record.status;
  return(
      <>
        {
          isDone === "IS_DONE"?
          <PdfDownloadButton controller="pdfreport" record={props.record}/>
          :
          null
        }
      </>
)};



const STATUS_STYLES = {
  IS_ACTIVE: { label: "Odprto", color: COLORS.warning, background: COLORS.warningLight },
  IS_DONE: { label: "Končano", color: COLORS.success, background: COLORS.successLight },
  IS_CANCELED: { label: "Preklicano", color: COLORS.neutral, background: COLORS.neutralLight }
};

const StatusField = ({ record }) => {
  const status = record && STATUS_STYLES[record.status];
  if (!status) return null;

  return (
    <span
      style={{
        padding: "4px 10px",
        borderRadius: 999,
        backgroundColor: status.background,
        color: status.color,
        fontSize: 12,
        fontWeight: 600,
        whiteSpace: "nowrap"
      }}
    >
      {status.label}
    </span>
  );
};

const OrderTable = props => (
  <List {...props} exporter={false} filters={<OrderFilter />}   bulkActionButtons={false}>
    <Datagrid>
      <TextField label="resources.misc.fields.orderNumber" source="orderNumber" />
      <DateField label="resources.misc.fields.startInstallationDate" source="startInstallationDate" />
      <TextField label="resources.misc.fields.type" source="type" />
      <TextField label="resources.misc.fields.clientCustomer" source="clientCustomer.companyName" />
      <TextField label="resources.misc.fields.appUser" source="appUser.firstName"/>
      <StatusField label="resources.misc.fields.status" sortable={false} />
      <EditButton label="" /> 
      <ShowDownloadButton/>
    </Datagrid>
  </List>
);

const VIEW_STORAGE_KEY = "ordersView";

const viewSwitchStyles = {
  bar: {
    display: "flex",
    justifyContent: "flex-end",
    height: 40,
    marginTop: -54,
    marginBottom: 14
  },
  group: {
    display: "inline-flex",
    padding: 3,
    borderRadius: 10,
    backgroundColor: "#fff",
    border: `1px solid ${COLORS.border}`
  },
  button: {
    minHeight: 32,
    padding: "4px 14px",
    borderRadius: 8,
    color: COLORS.muted
  },
  active: {
    backgroundColor: COLORS.primaryLight,
    color: COLORS.primary
  }
};

/** Orders as a table or as a calendar like in the mobile app. */
export class OrderList extends Component {
  state = { view: localStorage.getItem(VIEW_STORAGE_KEY) === "calendar" ? "calendar" : "table" };

  setView = view => {
    localStorage.setItem(VIEW_STORAGE_KEY, view);
    this.setState({ view });
  };

  render() {
    const { view } = this.state;
    const option = (value, label, Icon) => (
      <MuiButton
        onClick={() => this.setView(value)}
        aria-pressed={view === value}
        style={{ ...viewSwitchStyles.button, ...(view === value ? viewSwitchStyles.active : {}) }}
      >
        <Icon style={{ marginRight: 6, fontSize: 20 }} />
        {label}
      </MuiButton>
    );

    return (
      <div>
        <div style={viewSwitchStyles.bar}>
          <div style={viewSwitchStyles.group} role="group" aria-label="Pogled">
            {option("table", "Tabela", ViewListIcon)}
            {option("calendar", "Koledar", DateRangeIcon)}
          </div>
        </div>
        {view === "table" ? (
          <OrderTable {...this.props} />
        ) : (
          <Card>
            <OrderCalendar history={this.props.history} />
          </Card>
        )}
      </div>
    );
  }
}

const OrderTitle = ({ record }) => {
    return (
      <span>{record ? `Delovni nalog ${record.orderNumber || ""}` : ""}</span>
    );
};

// Pinned to the top right corner of the card instead of floating, so the
// line under the form tabs runs the full width.
const cardActionStyle = {
    position: "absolute",
    top: 22,
    right: 16,
    zIndex: 2,
    padding: 0
};

/** PDF download on an opened order; the report only exists once the order is done. */
const OrderPdfAction = ({ record }) =>
  record && record.id ? (
    <PdfDownloadButton
      controller="pdfreport"
      record={record}
      labeled
      disabled={record.status !== "IS_DONE"}
      disabledReason="PDF je na voljo, ko je nalog zaključen."
    />
  ) : null;

const OrderEditActions = ({ data }) => (
  <CardActions style={cardActionStyle}>
    <OrderPdfAction record={data} />
  </CardActions>
);

// a new order has nothing to edit yet, so no "Uredi" button here
const CreateActions = ({ basePath }) => (
  <CardActions style={cardActionStyle}>
    <ListButton basePath={basePath} />
  </CardActions>
);

const Actions = ({ basePath, data, refresh }) => (
  <CardActions style={cardActionStyle}>
    <OrderPdfAction record={data} />
    <EditButton basePath={basePath} record={data} />
    <ListButton basePath={basePath} />
  </CardActions>
);

const statusOptions = ['IS_ACTIVE', 'IS_DONE', 'IS_CANCELED'];
// Dodatno tab: one tidy row per check (label left, its options right), instead of floated checkboxes
const yesNoOptions = (no, yes) => [
  { source: no, label: "resources.misc.fields.no" },
  { source: yes, label: "resources.misc.fields.yes" }
];
const ratingOptions = (good, maraeble, bad) => [
  { source: good, label: "resources.misc.fields.good" },
  { source: maraeble, label: "resources.misc.fields.maraeble" },
  { source: bad, label: "resources.misc.fields.bad" }
];
const CHECK_GROUPS = [
  { title: "Izvedena dela", rows: [
    { label: "resources.misc.fields.cleaningFiltersSpatulasMasks", options: yesNoOptions("cleaningNo", "cleaningYes") },
    { label: "resources.misc.fields.desinfectionController", options: yesNoOptions("desinfectionNo", "desinfectionYes") },
    { label: "resources.misc.fields.testCondention", options: yesNoOptions("testCondentionNo", "testCondentionYes") },
    { label: "resources.misc.fields.checkCleaningEvaporator", options: yesNoOptions("checkCleaningEvaporatorNo", "checkCleaningEvaporatorYes") }
  ] },
  { title: "Stanje naprave", rows: [
    { label: "resources.misc.fields.tightness", options: ratingOptions("tightnessGood", "tightnessMaraeble", "tightnessBad") },
    { label: "resources.misc.fields.cleanliness", options: ratingOptions("cleanlinessGood", "cleanlinessMaraeble", "cleanlinessBad") },
    { label: "resources.misc.fields.ratingZd", options: ratingOptions("ratingGood", "ratingMaraeble", "ratingBad") }
  ] }
];

const checkStyles = {
  group: { maxWidth: 820, marginBottom: 20 },
  title: { margin: "4px 0 6px", color: COLORS.muted, fontSize: 12, fontWeight: 700, letterSpacing: 0.5, textTransform: "uppercase" },
  row: { display: "flex", alignItems: "center", flexWrap: "wrap", borderBottom: `1px solid ${COLORS.grid}` },
  label: { flex: "1 1 280px", padding: "6px 16px 6px 0", color: COLORS.text, fontSize: 15 },
  options: { display: "flex", flex: "0 0 auto" },
  option: { margin: "4px 0", minWidth: 120 }
};

const CheckGroups = translate(({ translate }) => (
  <div>
    {CHECK_GROUPS.map(group => (
      <div key={group.title} style={checkStyles.group}>
        <div style={checkStyles.title}>{group.title}</div>
        {group.rows.map(row => (
          <div key={row.label} style={checkStyles.row}>
            <div style={checkStyles.label}>{translate(row.label, { _: row.label })}</div>
            <div style={checkStyles.options}>
              {row.options.map(option => (
                <CheckboxInput key={option.source} source={option.source} label={option.label} style={checkStyles.option} />
              ))}
            </div>
          </div>
        ))}
      </div>
    ))}
  </div>
));

const gasOptions = ['','R410a', 'R407c', 'R22', 'R32']; // same refrigerants as the app

const toChoices = items => (
  items.map(item => ({ id: item, name: mapChoice(item) }))
)

const mapChoice = item => {
  if(item == "IS_ACTIVE") return "Odprto";
  if(item == "IS_DONE") return "Končano";
  if(item == "IS_CANCELED") return "Preklicano";
  return item;
}


export const OrderShow = props => (
  <Show 
  title={<OrderTitle />} 
  actions={<Actions />}
  {...props}>
    <SimpleShowLayout>
      <TextField label="resources.misc.fields.orderNumber" source="orderNumber" />
      <TextField label="resources.misc.fields.type" source="type" />
      <TextField label="resources.misc.fields.clientCustomer" source="clientCustomer.email" />
      <TextField label="resources.misc.fields.subscriber" source="subscriber.title" />
      <TextField label="resources.misc.fields.appUser" source="appUser.email"/>
      <DateField label="resources.misc.fields.orderDate" source="orderDate" />
      <DateField label="resources.misc.fields.startInstallationDate" source="startInstallationDate" />
      <DateField label="resources.misc.fields.endInstallationDate" source="endInstallationDate" />
      <TextField label="resources.misc.fields.manual" source="manual" />
      <TextField label="resources.misc.fields.notes1" source="notes1" />
      <TextField label="resources.misc.fields.notes2" source="notes2" />
      <DateField label="resources.misc.fields.createdAt" source="createdAt" />
      <DateField label="resources.misc.fields.updatedAt" source="updatedAt" />
      <StatusField label="resources.misc.fields.status" addLabel />

      <TextField label="resources.misc.fields.desinfectionController"/>
      <BooleanTextField label="resources.misc.fields.no" source="desinfectionNo" style={{ display: 'inline', float: 'left', display: 'block' }}/>
      <BooleanTextField label="resources.misc.fields.yes" source="desinfectionYes" style={{display:'block'}}/>
      <TextField label="resources.misc.fields.testCondention"/>
      <BooleanTextField label="resources.misc.fields.no" source="testCondentionNo" style={{ display: 'inline', float: 'left' }}/>
      <BooleanTextField label="resources.misc.fields.yes" source="testCondentionYes"/>

      <TextField label="resources.misc.fields.checkCleaningEvaporator"/>
      <BooleanTextField label="resources.misc.fields.no" source="checkCleaningEvaporatorNo" style={{ display: 'inline', float: 'left' }}/>
      <BooleanTextField label="resources.misc.fields.yes" source="checkCleaningEvaporatorYes"/>
      <TextField label="resources.misc.fields.tightness"/>
      <BooleanTextField label="resources.misc.fields.good" source="tightnessGood" style={{ display: 'inline', float: 'left' }}/>
      <BooleanTextField label="resources.misc.fields.maraeble" source="tightnessMaraeble" style={{ display: 'inline', float: 'left' }}/>
      <BooleanTextField label="resources.misc.fields.bad" source="tightnessBad"/>
      <TextField label="resources.misc.fields.cleanliness"/>
      <BooleanTextField label="resources.misc.fields.good" source="cleanlinessGood" style={{ display: 'inline', float: 'left' }}/>
      <BooleanTextField label="resources.misc.fields.maraeble" source="cleanlinessMaraeble" style={{ display: 'inline', float: 'left' }}/>
      <BooleanTextField label="resources.misc.fields.bad" source="cleanlinessBad"/>
      <TextField label="resources.misc.fields.ratingZd"/>
      <div>
      <BooleanTextField label="resources.misc.fields.good" source="ratingGood" style={{ display: 'inline', float: 'left', display: 'block' }}/>
      <BooleanTextField label="resources.misc.fields.maraeble" source="ratingMaraeble" style={{ display: 'inline', float: 'left', display: 'block' }}/>
      <BooleanTextField label="resources.misc.fields.bad" source="ratingBad"/>
      </div>
      <TextField
      label="resources.misc.fields.breathMeasurement"
      source="breathMeasurement"
      />
      <TextField
      label="resources.misc.fields.pressureMeasurement"
      source="pressureMeasurement"
      />
      <TextField
      label="resources.misc.fields.gas"
      source="gas"
      />
    </SimpleShowLayout>
  </Show>
);

export const OrderEdit = ({ permissions, ...props }) => (
  <Edit title={<OrderTitle />} actions={<OrderEditActions />} {...props}>

          <TabbedForm>
            <FormTab label="Osnovni podatki">
            
              <SelectInput label="resources.misc.fields.type"
                    source="type" choices={[
                      { id: 'Montaza', name: 'Montaža' },
                      { id: 'Servis', name: 'Servis' },
                      { id: 'Drugo', name: 'Drugo' },
                ]} />
                
              <TextInput
                label="resources.misc.fields.contractor"
                source="contractor"
              />
                
              <ReferenceInput
                  label="resources.misc.fields.subscribers"
                  sort={{ field: "id", order: "ASC" }}
                  source="subscriber.id"
                  reference="subscribers"
                allowEmpty
              >
              <SelectInput  optionText={choice =>`${choice.title}`} options={{fullWidth: true}} optionValue="id" />
              </ReferenceInput>
              <ReferenceInput
                  label="resources.misc.fields.clientCustomer"
                  sort={{ field: "id", order: "ASC" }}
                  source="clientCustomer.id"
                  reference="clientCustomers"
                allowEmpty
              >
              <SelectInput  optionText={choice =>(choice.companyName==null)?`${choice.firstName} ${choice.lastName}`:`${choice.companyName}`} options={{fullWidth: true}} optionValue="id" />
              </ReferenceInput>
              <SelectInput
                label="resources.misc.fields.status"
                source="status"
                choices={toChoices(statusOptions)}
              />
            </FormTab>
            
            <FormTab label="Ekipa">
               <ReferenceInput
                  label="resources.misc.fields.appUser"
                  sort={{ field: "id", order: "ASC" }}
                  source="appUser.id"
                  reference="appUsers"
                  allowEmpty
                >
                  <SelectInput optionText="firstName" optionValue="id" />
              </ReferenceInput>

              <ReferenceArrayInput  source="workersPks" reference="appUsers" perPage={100} label="resources.misc.fields.workers">
                  <SelectArrayInput optionText="firstName" />
              </ReferenceArrayInput>
            </FormTab>

            <FormTab label="Datumi">
              <DateTimeInput
                label="resources.misc.fields.startInstallationDate"
                source="startInstallationDate"
              />
              <DateTimeInput
                label="resources.misc.fields.endInstallationDate"
                source="endInstallationDate"
              />
            </FormTab>
            <FormTab label="Opis">
              {/* notes are often several sentences, so they get wide multi-line fields */}
              {["manual", "notes1", "notes2", "customerComment", "additionalDesc"].map(field => (
                <TextInput
                  key={field}
                  label={`resources.misc.fields.${field}`}
                  source={field}
                  multiline
                  rows={4}
                  rowsMax={12}
                  fullWidth
                  style={{ maxWidth: 820 }}
                />
              ))}
            </FormTab>
            <FormTab label="Materiali">
              <EmbeddedArrayInput source="material" labelAdd="resources.misc.fields.material" addText="Dodaj material">
                    <TextInput source="type" label="resources.misc.fields.material" fullWidth style={{ flex: "3 1 260px" }} />
                    <TextInput source="quantity" label="resources.misc.fields.quantity" fullWidth style={{ flex: "1 1 120px" }} />
              </EmbeddedArrayInput>
            </FormTab>
            <FormTab label="Naprave">
            <EmbeddedArrayInput source="orderDevices" labelAdd="resources.misc.fields.orderDevices" addText="Dodaj napravo">
                <ReferenceInput
                        source="device.id"
                        reference="devices"
                        label="resources.misc.fields.device"
                        allowEmpty
                        style={{ flex: "1 1 160px" }}
                    >
                        <SelectInput  optionText={choice => `${choice.manufacturer}`} options={{fullWidth: true}} optionValue="id" />
                    </ReferenceInput>
                    <TextInput source="model" label="resources.misc.fields.model" fullWidth style={{ flex: "1 1 160px" }} />
                    <TextInput source="serialNumber" label="resources.misc.fields.serialNumber" fullWidth style={{ flex: "1 1 160px" }} />
                    <TextInput source="buildYear" label="resources.misc.fields.buildYear" fullWidth style={{ flex: "1 1 110px" }} />
                    <TextInput source="power" label="resources.misc.fields.power" fullWidth style={{ flex: "1 1 110px" }} />
            </EmbeddedArrayInput>
            </FormTab>
            <FormTab label="Dodatno">
              <CheckGroups />
                <TextInput
                label="resources.misc.fields.breathMeasurement"
                source="breathMeasurement"
                />
                <TextInput
                label="resources.misc.fields.pressureMeasurement"
                source="pressureMeasurement"
                />

                <SelectInput
                label="resources.misc.fields.gas"
                source="gas"
                choices={toChoices(gasOptions)}
              />
            </FormTab>
            <FormTab label="Podpisi">
            <Base64Image />
            </FormTab>
            <FormTab label="Slike">
            <Base64ImageInstallation />
            </FormTab>
          </TabbedForm>

  </Edit>
);


export const OrderCreate = ({ permissions, ...props }) => (
  <Create title="Nov delovni nalog" actions={<CreateActions />} {...props}>
    <TabbedForm redirect="list">
            <FormTab label="Ustvari naročilo">
            
               <SelectInput label="resources.misc.fields.type"
                    source="type" choices={[
                    { id: 'Montaza', name: 'Montaža' },
                    { id: 'Servis', name: 'Servis' },
                    { id: 'Drugo', name: 'Drugo' },
                ]} />

              <TextInput
                label="resources.misc.fields.contractor"
                source="contractor"
              />

              <ReferenceInput
                  label="resources.misc.fields.subscribers"
                  sort={{ field: "id", order: "ASC" }}
                  source="subscriber.id"
                  reference="subscribers"
              >
              <SelectInput  optionText={choice =>`${choice.title}`} options={{fullWidth: true}} optionValue="id" />
              </ReferenceInput>
              <SubscriberAdd />

              
              <ReferenceInput
                  label="resources.misc.fields.clientCustomer"
                  sort={{ field: "id", order: "ASC" }}
                  source="clientCustomer.id"
                  reference="clientCustomers"
              >
               <SelectInput optionText={choice =>`${choice.firstName} ${choice.lastName}`} options={{fullWidth: true}} optionValue="id" />
              </ReferenceInput>
              <ClientAdd />
              
              
              <SelectInput
                label="resources.misc.fields.status"
                source="status"
                choices={toChoices(statusOptions)}
              />
               <ReferenceInput
                  label="resources.misc.fields.appUser"
                  sort={{ field: "id", order: "ASC" }}
                  source="appUser.id"
                  reference="appUsers"
                >
                  <SelectInput optionText="firstName" optionValue="id" />
              </ReferenceInput>

              <ReferenceArrayInput source="workersPks" reference="appUsers" perPage={100} label="resources.misc.fields.workers">
                  <SelectArrayInput optionText="firstName" />
              </ReferenceArrayInput>
            
              <DateTimeInput
                label="resources.misc.fields.startInstallationDate"
                source="startInstallationDate"
              />
              <DateTimeInput
                label="resources.misc.fields.endInstallationDate"
                source="endInstallationDate"
              />
           
              <TextInput
                label="resources.misc.fields.manual"
                source="manual"
              />
              <TextInput
                label="resources.misc.fields.notes1"
                source="notes1"
                />
            </FormTab>
          </TabbedForm>
  </Create>
);